import { useEffect } from "react";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NoiseOverlay from "@/components/recon/NoiseOverlay";
import EnvelopeLoader from "@/components/recon/EnvelopeLoader";
import Navbar from "@/components/recon/Navbar";
import Hero from "@/components/recon/Hero";
import Marquee from "@/components/recon/Marquee";
import Question from "@/components/recon/Question";
import Bridge from "@/components/recon/Bridge";
import WhatIsRecon from "@/components/recon/WhatIsRecon";
import Experience from "@/components/recon/Experience";
import Pillars from "@/components/recon/Pillars";
import Exchange from "@/components/recon/Exchange";
import FieldGuide from "@/components/recon/FieldGuide";
import WhoFor from "@/components/recon/WhoFor";
import Outcome from "@/components/recon/Outcome";
import Details from "@/components/recon/Details";
import FinalInvite from "@/components/recon/FinalInvite";
import Checkout from "@/components/recon/Checkout";
import PaymentSuccess from "@/components/recon/PaymentSuccess";
import PaymentCancel from "@/components/recon/PaymentCancel";
import AdminDashboard from "@/components/recon/AdminDashboard";
import Debrief from "@/components/recon/Debrief";

function Landing() {
  return (
    <>
      <EnvelopeLoader />
      <Navbar />
      <main>
        <Hero />
        <Marquee testid="mission-marquee" items={["PAUSE", "ASSESS", "GATHER", "MOVE"]} />
        <Question />
        <Bridge />
        <WhatIsRecon />
        <Experience />
        <Pillars />
        <Exchange />
        <FieldGuide />
        <WhoFor />
        <Outcome />
        <Details />
        <FinalInvite />
      </main>
    </>
  );
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="min-h-screen bg-bone font-sans text-ink antialiased selection:bg-wine selection:text-bone">
        <NoiseOverlay />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/debrief" element={<Debrief />} />
          </Routes>
        </BrowserRouter>
      </div>
    </MotionConfig>
  );
}

export default App;
